(function () {
  /* === FILTERBALK === */
  const filterForm = document.getElementById('bkcFilters');
  if (filterForm) {
    /* Lege prijsvelden niet als lege ?param in de URL zetten */
    function submitFilters() {
      filterForm.querySelectorAll('input[type="number"]').forEach(i => {
        if (!i.value) i.disabled = true;
      });
      filterForm.submit();
    }
    filterForm.addEventListener('change', (e) => {
      if (e.target.type === 'number') return;
      submitFilters();
    });
    filterForm.querySelectorAll('input[type="number"]').forEach(input => {
      let timer;
      input.addEventListener('change', () => {
        clearTimeout(timer);
        timer = setTimeout(submitFilters, 400);
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); submitFilters(); }
      });
    });
    /* Eén filterpaneel tegelijk open, en dicht bij klik ernaast */
    const facets = Array.from(filterForm.querySelectorAll('[data-facet]'));
    facets.forEach(d => {
      d.addEventListener('toggle', () => {
        if (d.open) facets.forEach(o => { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-facet]')) facets.forEach(d => { d.open = false; });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') facets.forEach(d => { d.open = false; });
    });
  }
  /* === INFINITY SCROLL === */
  const anchor = document.querySelector('.bkc-load-more-anchor');
  let isLoading = false;
  let nextUrl = anchor ? anchor.dataset.loadNextUrl : null;
  async function loadNext() {
    if (!nextUrl || isLoading || !anchor) return;
    isLoading = true;
    anchor.classList.add('is-loading');
    try {
      const r = await fetch(nextUrl);
      if (!r.ok) throw new Error('Status ' + r.status);
      const html = await r.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('.bkc-grid');
      const newAnchor = doc.querySelector('.bkc-load-more-anchor');
      const grid = document.querySelector('.bkc-grid');
      if (!newGrid || !grid) throw new Error('No grid found in response');
      Array.from(newGrid.children).forEach(card => grid.appendChild(card));
      nextUrl = newAnchor ? newAnchor.dataset.loadNextUrl : null;
      if (!nextUrl) {
        anchor.classList.add('is-done');
        anchor.innerHTML = '<div class="bkc-empty-cta"><p>Je hebt alle producten gezien</p></div>';
      }
      bindQuickAdd();
    } catch (e) {
      console.error('Infinity scroll error', e);
      anchor.innerHTML = '<p style="color:#aaa;">Kon niet meer producten laden. <a href="' + (nextUrl || '#') + '" style="color:#E89B2E;text-decoration:underline;">Klik hier voor pagina 2</a></p>';
    } finally {
      anchor.classList.remove('is-loading');
      isLoading = false;
    }
  }
  if (anchor && nextUrl && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) loadNext(); });
    }, { rootMargin: '400px' });
    io.observe(anchor);
  }
  /* === QUICK ADD CART === */
  function bindQuickAdd() {
    document.querySelectorAll('[data-quick-add]:not([data-bound])').forEach(btn => {
      btn.dataset.bound = '1';
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (btn.classList.contains('is-loading')) return;
        const variantId = btn.dataset.quickAdd;
        const label = btn.querySelector('.bkc-btn-label');
        const origText = label ? label.textContent : btn.textContent;
        btn.classList.add('is-loading');
        try {
          const sectionId = (window.fluxCart && window.fluxCart.getHeaderSectionId)
            ? window.fluxCart.getHeaderSectionId() : null;
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }],
              sections: sectionId,
              sections_url: window.location.pathname
            })
          });
          if (!r.ok) throw new Error('Add failed: ' + r.status);
          const resp = await r.json();
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          if (label) label.textContent = 'Toegevoegd ✓';
          else btn.textContent = 'Toegevoegd ✓';
          if (window.fluxCart && window.fluxCart.applyCartSections && resp.sections) {
            window.fluxCart.applyCartSections(resp.sections);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
          if (window.fluxCart && window.fluxCart.openCartDrawer) {
            window.fluxCart.openCartDrawer();
          } else {
            const cartIcon = document.querySelector('[aria-label*="winkelwagen" i], a[href="/cart"], [aria-label*="cart" i]');
            if (cartIcon && cartIcon.click) setTimeout(() => cartIcon.click(), 50);
          }
          setTimeout(() => {
            btn.classList.remove('is-added');
            if (label) label.textContent = origText;
            else btn.textContent = origText;
          }, 2000);
        } catch (err) {
          btn.classList.remove('is-loading');
          if (label) label.textContent = 'Fout - probeer opnieuw';
          else btn.textContent = 'Fout';
          setTimeout(() => {
            if (label) label.textContent = origText;
            else btn.textContent = origText;
          }, 2000);
        }
      });
    });
  }
  bindQuickAdd();

  /* === ZOEKBALK MET AUTOCOMPLETE (Shopify predictive search) === */
  const sInput = document.getElementById('bk-search-input');
  const sList  = document.getElementById('bk-suggest-list');
  const sForm  = document.getElementById('bk-search-form');
  if (sInput && sList && sForm) {
    let active = -1;
    let items = [];
    let controller = null;
    const debounce = (fn, d) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), d); }; };
    function close() {
      sList.classList.remove('is-open');
      sInput.setAttribute('aria-expanded', 'false');
      active = -1;
    }
    function highlight() {
      items.forEach((el, i) => el.setAttribute('aria-selected', i === active ? 'true' : 'false'));
      if (active >= 0 && items[active]) items[active].scrollIntoView({ block: 'nearest' });
    }
    async function suggest(q) {
      if (!q || q.trim().length < 2) { close(); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      const url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=8'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,vendor';
      try {
        const r = await fetch(url, { signal: controller.signal });
        if (!r.ok) throw new Error(r.status);
        const data = await r.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          sList.innerHTML = '<p class="bkc-suggest-empty">Geen suggesties. Druk op Zoeken voor alle resultaten.</p>';
        } else {
          /* De predictive-API geeft een onbewerkte prijs ("11.95") en een full-size
             afbeelding terug; allebei hier omzetten naar iets bruikbaars. */
          const money = v => '\u20AC' + String(v).replace('.', ',');
          const thumb = u => u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=92';
          sList.innerHTML = products.map(p => {
            const img = p.featured_image && p.featured_image.url
              ? '<img class="bkc-suggest-img" src="' + thumb(p.featured_image.url) + '" alt="" loading="lazy" width="46" height="46">'
              : '<span class="bkc-suggest-img"></span>';
            const price = p.price ? '<span class="bkc-suggest-price">' + money(p.price) + '</span>' : '';
            return '<a class="bkc-suggest-item" role="option" aria-selected="false" href="' + p.url + '">'
              + img + '<span class="bkc-suggest-title">' + p.title + '</span>' + price + '</a>';
          }).join('');
        }
        items = Array.from(sList.querySelectorAll('.bkc-suggest-item'));
        active = -1;
        sList.classList.add('is-open');
        sInput.setAttribute('aria-expanded', 'true');
      } catch (e) {
        if (e.name !== 'AbortError') close();
      }
    }
    const run = debounce(() => suggest(sInput.value), 200);
    sInput.addEventListener('input', run);
    sInput.addEventListener('focus', () => { if (sInput.value.trim().length >= 2) run(); });
    sInput.addEventListener('keydown', (e) => {
      if (!sList.classList.contains('is-open') || !items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); active = (active + 1) % items.length; highlight(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = (active - 1 + items.length) % items.length; highlight(); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); window.location.href = items[active].href; }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('.bkc-search-wrap')) close(); });
    sForm.addEventListener('submit', () => close());
  }
})();
